import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_GET_ASSET_CONFIG_DATA,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_CONFIG_DATA,
} from '../constants';

const api = ({ solutionId, twinId, fileName }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_GET_ASSET_CONFIG_DATA, {
      solutionId,
      twinId,
    }),
    queryParams: { fileName },
  });

const assetConfigFile = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_CONFIG_DATA,
  responseMapping: ResponseMapping.Default,
});

export default assetConfigFile;
